import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rowDetailVisible',
})
export class RowDetailVisiblePipe implements PipeTransform {
  transform(value: any, showDetailsPipe?: PipeTransform): boolean {
    if (value != null && showDetailsPipe != null) {
      return showDetailsPipe.transform ? showDetailsPipe.transform(value) : true;
    } else {
      return true;
    }
  }
}
